import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import API from '../../utils/api';

const styles = () => ({
  select: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
  },
  formControl: {
    width: '100%',
  },
});

class LeagueTeamSorting extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      apiList: [],
      teamList: [],
    };

    this.mounted = false;
  }

  componentDidMount() {
    this.fetchData(this.props.league, this.props.query);
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleChange(name, value) {
    this.setState({ [name]: value });
  }

  async fetchData(leagueId, query) {
    const { data: dataLeagues } = await API.getLeagues({
      ignoreDependencies: true,
      query: query ? query : {},
    });

    if (dataLeagues) {
      const leagueList = dataLeagues.docs;

      if (this.mounted) {
        this.setState({ apiList: leagueList });
      }
    }
    if (leagueId) {
      let query = { leagues: leagueId };
      query = JSON.stringify(query);
      const { data: dataTeams } = await API.getTeams({ query, ignoreDependencies: true });
      if (dataTeams && dataTeams.docs) {
        const teamList = dataTeams.docs;
        if (this.mounted) {
          this.setState({ teamList });
        }
      }
    }
  }

  renderSelect(title, value, options, onChange, disabled) {
    const { classes } = this.props;

    return (
      <FormControl className={classes.formControl}>
        <InputLabel>{title}</InputLabel>

        <Select
          value={value || ''}
          onChange={event => onChange(event.target.value)}
          disabled={disabled}
        >
          <MenuItem value={null}>
            <em>None</em>
          </MenuItem>

          {options.map(row => (
            <MenuItem key={row._id} value={row._id}>
              <div className={classes.select}>{row.name}</div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  render() {
    const {
      league,
      changeLeague,
      team,
      changeTeam,
      direction = 'row',
      disabled,
    } = this.props;

    const { apiList, teamList } = this.state;

    return (
      <div style={{ display: 'flex', marginRight: 15, flexDirection: direction }}>
        <div
          style={
            direction === 'row' ? { minWidth: 150, marginRight: 15 } : { minWidth: 250 }
          }
        >
          {this.renderSelect(
            'League',
            league,
            apiList,
            value => {
              changeLeague(value);
              changeTeam(null, true);
              this.fetchData(value);
            },
            disabled
          )}
        </div>

        <div
          style={
            direction === 'row' ? { minWidth: 150 } : { minWidth: 250, marginTop: 15 }
          }
        >
          {this.renderSelect('Team', team, teamList, changeTeam)}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(LeagueTeamSorting);
